const React = require('react');
const { NavLink } = require('react-router-dom');

const ValueSpace = (props) => {
  const { type, Values, MinLength, MaxLength, Max, Min } = props.valuespace;
    let values = type || '';
    if (MinLength || MaxLength) values = `String: <${MinLength} - ${MaxLength}> characters`;
    else if (Min || Max) values = `Number: <${Min} - ${Max}>`;
    else if (type === 'Literal') values = Values.join(', ');
    else if (type === 'LiteralArray' && Values?.length) values = Values.join(', ');
  return values;
};

function typeName(type) {
  if (!type) return '?';
  return type.replace?.('Literal', '');
}

function parseKeywordDescriptions(input) {
  const regex = /(\S+)\s*:\s*(.*?)(?=\s+\S+\s*:|$)/g;
  const result = [];
  let match;

  while ((match = regex.exec(input)) !== null) {
    result.push({
      keyword: match[1],
      description: match[2].trim(),
    });
  }

  return result;
}

// some param descriptions contain descriptions per literal, separated by ':'.
// example: /xapi/Command.SystemUnit.FactoryReset
function parseDescription(desc) {
  if (desc.split(':')?.length < 2) return desc;
  const lines = parseKeywordDescriptions(desc);
  return (
    <>
      {lines.map(({ keyword, description }, n) => (
        <div style={{ marginTop: 10 }} key={n}>{keyword}: {description}</div>
      ))}
    </>
  );
}

const CommandParams = (props) => {
  const { params, multiline } = props;
  const list = params.map((param) => {
    const { name, required, valuespace = false, description } = param;
    const type = typeName(valuespace);
    const def = param.default;
    const defaultValue = def ? `Default: ${def}` : '';
    const values = <ValueSpace valuespace={valuespace} />;

    const req = required ? <span className="required">Required</span> : '';
    const info = description && (
      <div className="description">{parseDescription(description)}</div>
    );

    const symbol = valuespace?.type?.includes('Array') ? '*' : '';
    return (
      <div key={name} className="param">
        <div className="name">{name}{symbol}</div>
        <div>{req} {type} {values} {defaultValue} {info}</div>
      </div>
    );
  });
  const multilineInfo = multiline && (
    <div className="note">This is a multi-line command. Raw data can be sent as an unnamed parameter.
    <NavLink to="/doc/TechDocs/xAPI#multiline-commands" target="_blank" style={{ textDecoration: 'underline' }}>
      Read more...
    </NavLink>
  </div>);

  const multiParam = params.some(p => p.valuespace?.type?.includes('Array'));
  const multiParamInfo = multiParam && (
  <div className="note">* This command supports parameters that can be used multiple times.
    <NavLink to="/doc/TechDocs/JSXAPIXapiToJs#commands" target="_blank" style={{ textDecoration: 'underline' }}>
      Read more...
    </NavLink>
  </div>);

  const noParams = !params.length && <i>No parameters</i>;
  return (
    <div>
      <div className="params">
        {list}
        {noParams}
      </div>
      {multiParamInfo}
      {multilineInfo}
    </div>
  );
};

module.exports = CommandParams;
